import UploadProgressBar from 'app/components/UploadProgressBar';

const UploadUploadProgressBar = props => {
  const {
    upload
  } = props;

  let matchFileContext = {
    groupId: upload.id
  }

  let total = upload.file_count;
  let loaded = upload.completed_count;

  return <UploadProgressBar {...{ matchFileContext, total, loaded }} />;
}

export default UploadUploadProgressBar;
